import {store, getElement, getContext} from "@wordpress/interactivity";

const {actions, callbacks} = store("wpbs/archive-filters", {
    state: {
        values: {},
        hasValue: () => {
            const context = getContext();
            const {state} = store("wpbs/archive-filters");
            return !!state.values[context.key];
        }
    },
    callbacks: {
        updateQuery(value) {
            const context = getContext();
            const {key} = context || {};

            if (!key) return;

            const url = new URL(window.location.href);
            const params = url.searchParams;

            if (key === 'combined') {
                if (!value) {
                    params.delete('orderby');
                    params.delete('order');
                } else {
                    const mapping = {
                        latest: {orderby: 'date', order: 'desc'},
                        oldest: {orderby: 'date', order: 'asc'},
                        shuffle: {orderby: 'rand', order: 'desc'},
                        title: {orderby: 'title', order: 'asc'},
                        'title-reverse': {orderby: 'title', order: 'desc'},
                    };
                    const config = mapping[value];
                    if (config) {
                        params.set('orderby', config.orderby);
                        params.set('order', config.order);
                    }
                }
            } else {
                if (!value) {
                    params.delete(key);
                } else {
                    params.set(key, value);
                }
            }

            window.location.href = url.toString();
        },
    },
    actions: {
        initField() {
            const element = getElement()?.ref;
            const context = getContext();
            const {type, key} = context || {};
            const {state} = store("wpbs/archive-filters");

            if (!key || !element) return;

            const params = new URLSearchParams(window.location.search);
            let value = params.get(key);

            if (key === 'combined') {
                const orderby = params.get('orderby');
                const order = params.get('order')?.toLowerCase();

                if (orderby === 'date' && order === 'desc') value = 'latest';
                else if (orderby === 'date' && order === 'asc') value = 'oldest';
                else if (orderby === 'rand') value = 'shuffle';
                else if (orderby === 'title' && order !== 'desc') value = 'title';
                else if (orderby === 'title' && order === 'desc') value = 'title-reverse';
            }

            if (value !== null && value !== undefined) {
                state.values[key] = value;

                if (type === 'select') {
                    const currentOption = element.querySelectorAll('option[selected]');
                    const nextOption = element.querySelector(`option[value="${value}"]`);

                    [...currentOption].forEach(option => option.removeAttribute('selected'));

                    if (nextOption !== null) {
                        nextOption.selected = true;
                    }
                }

                if (type === 'search') {
                    element.value = value;
                }
            } else {
                state.values[key] = '';
            }
        },

        handleKeyDown(event) {
            if (event.key === 'Enter') {
                actions.submitSearch();
            }
        },

        handleInput(event) {
            const {key} = getContext();
            const {state} = store("wpbs/archive-filters");
            state.values[key] = event.target.value;
        },

        clearField() {
            const {key} = getContext();
            const {state} = store("wpbs/archive-filters");
            state.values[key] = '';
            callbacks.updateQuery('');
        },

        submitSearch() {
            const element = getElement()?.ref;
            const parent = element?.closest('.wpbs-archive-filters');
            const field = parent?.querySelector('input[type="search"]');

            if (field) {
                callbacks.updateQuery(field.value);
            }
        },

        submitSelect(event) {
            callbacks.updateQuery(event.target.value);
        },
    },
});